var map = {
	"./livro1.png": 88,
	"./livro2.png": 89,
	"./livro3.png": 90,
	"./livro4.png": 91,
	"./livro5.png": 92,
	"./livro6.png": 93,
	"./livro7.png": 94,
	"./livro8.png": 95,
	"./livro9.png": 96
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87;